/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import FormData from "form-data";

import type { ApiRequestOptions } from "./ApiRequestOptions";
import { isDefined, isString, isBlob } from "./request-guards";

// Helper function to append value to form data
/**
 * appendFormDataValue function.
 *
 * @param {*} formData - Parameter description
 * @param {*} key - Parameter description
 * @param {*} value - Parameter description
 *
 * @returns {*} Return value description
 */
function appendFormDataValue(formData: FormData, key: string, value: any): void {
  if (isString(value) || isBlob(value)) {
    formData.append(key, value);
  } else {
    formData.append(key, JSON.stringify(value));
  }
}

// Helper function to process array values for form data
/**
 * processFormDataArray function.
 *
 * @param {*} formData - Parameter description
 * @param {*} key - Parameter description
 * @param {*} value - Parameter description
 *
 * @returns {*} Return value description
 */
function processFormDataArray(formData: FormData, key: string, value: any[]): void {
  value.forEach((v) => appendFormDataValue(formData, key, v));
}

// Helper function to process single form data entry
/**
 * processFormDataEntry function.
 *
 * @param {*} formData - Parameter description
 * @param {*} key - Parameter description
 * @param {*} value - Parameter description
 *
 * @returns {*} Return value description
 */
function processFormDataEntry(formData: FormData, key: string, value: any): void {
  if (Array.isArray(value)) {
    processFormDataArray(formData, key, value);
  } else {
    appendFormDataValue(formData, key, value);
  }
}

/**
 * getFormData function.
 *
 * @param {*} options - Parameter description
 *
 * @returns {*} Return value description
 */
export const getFormData = (
  options: ApiRequestOptions
): FormData | undefined => {
  if (!options.formData) {
    return undefined;
  }

  const formData = new FormData();

  Object.entries(options.formData)
    .filter(([_, value]) => isDefined(value))
    .forEach(([key, value]) => {
      processFormDataEntry(formData, key, value);
    });

  return formData;
};
